
import { useEffect, useState } from "react";
import { CTBRecords } from "../../helpers/interfaces";
import React from "react";
import { getAllCTBRecords } from "../../apiServices/CTBRecordsApi";
import { Grid, MenuItem, Pagination, Stack, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../../layouts/themes";

interface Props {
    ctbRecordsToView: string

}
function SAPCTBRecords(props: Props) {

    const [costTrialBlanceRecords, setCostTrialBlanceRecords] = useState<CTBRecords[]>([])
    const [filteredCostTrialBlanceRecords, setFilteredCostTrialBlanceRecords] = useState<CTBRecords[]>([])
    const [searchQuery,] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(40);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<CTBRecords[]>([])



    useEffect(() => {
        getAllCTBRecords(props.ctbRecordsToView).then(costTrialBlanceRecords => setCostTrialBlanceRecords(costTrialBlanceRecords))
    }, [props.ctbRecordsToView])

    useEffect(() => {
        setFilteredCostTrialBlanceRecords(costTrialBlanceRecords.filter(e =>
            (searchQuery === "" || e.wbsDesc.toLowerCase().includes(searchQuery.toLowerCase()) || e.glDesc.toLowerCase().includes(searchQuery.toLowerCase()))
        ));
        setCurrentPage(1);
    }, [searchQuery, costTrialBlanceRecords])


    useEffect(() => {
        setNumOfPages(Math.ceil(filteredCostTrialBlanceRecords.length / recordsPerPage))
    }, [recordsPerPage, filteredCostTrialBlanceRecords])

    useEffect(() => {
        const lastIndex = currentPage * recordsPerPage;
        const firstIndex = lastIndex - recordsPerPage;
        setCurrentPageRecords(filteredCostTrialBlanceRecords.slice(firstIndex, lastIndex))
    }, [currentPage, recordsPerPage, filteredCostTrialBlanceRecords])


    return (

        <>

            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <TableContainer className="shadow-md sm:rounded-lg">
                    <Table className='summary overflow-x-auto table-auto' size="small" aria-label="a dense table"
                        aria-labelledby="tableTitle"
                    >
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell style={{ fontSize: '11px', }}> SN</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}> JV Name</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Object Type</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Cost Object</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>WBS DESC</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Cost Element</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>GL DESC</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Class 6 (TEK$)</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Class 7 (TEK$)</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Class 8 (TEK$)</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>All (TEK$)</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Cutback 6 (TEK$)</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>WIP-Asset Tfer (TEK$)</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>CTB (TEK$)</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {currentPageRecords.map((item, index) => {
                                return <StyledTableRow key={index}>

                                    <StyledTableCell  >
                                        {index + 1 + ((currentPage - 1) * recordsPerPage)}
                                    </StyledTableCell>
                                    <StyledTableCell  >{item.jvName}</StyledTableCell>
                                    <StyledTableCell  >{item.ctbObject}</StyledTableCell>
                                    <StyledTableCell  >{item.costObject}</StyledTableCell>
                                    <StyledTableCell  >{item.wbsDesc}</StyledTableCell>
                                    <StyledTableCell  >{item.costElement}</StyledTableCell>
                                    <StyledTableCell  >{item.glDesc}</StyledTableCell>
                                    <StyledTableCell  >{item.class6}</StyledTableCell>
                                    <StyledTableCell  >{item.class7}</StyledTableCell>
                                    <StyledTableCell  >{item.class8}</StyledTableCell>
                                    <StyledTableCell  >{item.all}</StyledTableCell>
                                    <StyledTableCell  >{item.cutBack}</StyledTableCell>
                                    <StyledTableCell  >{item.wipAsset}</StyledTableCell>
                                    <StyledTableCell  >{item.ctb}</StyledTableCell>

                                    <StyledTableCell  >


                                    </StyledTableCell>

                                </StyledTableRow>
                            })}

                            {currentPageRecords.length === 0 &&
                                <tr>
                                    <StyledTableCell colSpan={13}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                                </tr>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <br />

            <nav>
                <div className=" flex flex-row ">
                    <div className=" flex items-start ">
                        <div className="px-6 py-2">Rows per page</div>&nbsp;
                        < Grid item xs={12} lg={3} >
                            <CustomTextField fullWidth id="fullWidth" select variant="outlined" size="small" name="RequestsNumbers" value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))} >

                                <MenuItem value="40">40</MenuItem >
                                <MenuItem value="55">55</MenuItem >
                                <MenuItem value="85">85</MenuItem >
                                <MenuItem value="125">125</MenuItem >
                                <MenuItem value="200">200</MenuItem >
                                <MenuItem value="255">255</MenuItem >
                                <MenuItem value="350">350</MenuItem >
                                <MenuItem value="500">500</MenuItem >


                            </CustomTextField>
                        </Grid>
                    </div>
                    <div style={{ flexGrow: 1 }} />
                    <Stack spacing={2}>
                        <Pagination color="secondary" count={numOfPages} siblingCount={1} boundaryCount={1}
                            onChange={(event, value) => setCurrentPage(value)} page={currentPage} size="small" classes={{ ul: "PaginationUl" }} />
                    </Stack>

                </div>
                <br />


            </nav>
        </>





    )
}
export default SAPCTBRecords;